import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Bookmark compatibility for the pre-HS-1212 `/institutes` paths.
 *
 * The section was renamed `/institutions` to match the copy, the API DTOs and the route param the
 * app has always used. A rename of a URL is a broken link for anyone who saved one, so every old
 * path answers here and forwards to its new equivalent.
 *
 * A splat rather than one file per path: the shape below `/institutes` is `new`, `$id` and
 * `$id/edit`, and re-declaring each would be four files that must be kept in step with the real
 * routes for no added precision. The tail is passed through untouched.
 *
 * No permission guard: `beforeLoad` throws the redirect before any loader runs, and the target
 * route's own `requireRoute` is what decides access. Gating here as well would answer an
 * unauthorised bookmark with the access-denied screen for the *old* URL, which tells the user
 * less than being sent to the real one.
 *
 * Removal criterion: drop this once the deploy logs show no `/institutes` hits for a full release
 * cycle. It is compatibility, not a second name for the section — nothing in the app links here.
 */
export const Route = createFileRoute('/_dashboard/institutes/$')({
  beforeLoad: ({ location }) => {
    // `href` rather than `to`: the destination is only known at runtime, and `to` is a union of
    // the routes the tree declares. Rewriting the one leading segment of the location keeps the
    // `$id`, any trailing `edit`, and the query string exactly as they arrived.
    throw redirect({
      href: location.href.replace('/institutes', '/institutions'),
      replace: true,
    });
  },
});
